"use client"

import { trackEvent } from "./track"

import type { FeedSectionClickEvent, FeedSectionImpressionEvent } from "./types/custom"

export function trackFeedSectionImpression(params: FeedSectionImpressionEvent["params"]): void {
  trackEvent("feed_section_impression", params)
}

export function trackFeedSectionClick(params: FeedSectionClickEvent["params"]): void {
  trackEvent("feed_section_click", params)
}
